/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetGraduatedPrice Input Action
 */
export class GetGraduatedPriceInput implements Msdyn365.IActionInput {
    public newValue: number;
    public productId: number;
    public catalogId: number;

    constructor(newValue: number, productId: number, catalogId: number) {
        this.newValue = newValue;
        this.productId = productId;
        this.catalogId = catalogId;
    }

    public getCacheKey = () => `GraduatedPrice`;
    public getCacheObjectType = () => 'GraduatedPrice';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetGraduatedPrice {
    ProductPrice: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetGraduatedPriceInput(0, 0, 0);
};

async function action(input: GetGraduatedPriceInput, ctx: Msdyn365.IActionContext): Promise<IGetGraduatedPrice> {
    let result: string = '';

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecGetPrice`,
        'post',
        {
            priceModel: {
                CatalogId: input.catalogId,
                ProductId: input.productId,
                Quantity: input.newValue
            }
        },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    )
        .then(res => {
            result = (res?.data as IGetGraduatedPrice).ProductPrice;
        })
        .catch(ex => {
            console.log('Error', ex);
        });

    return { ProductPrice: result };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetGraduatedPrice>>action,
    id: 'GetGraduatedPrice',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
